export class UserOptions {
  remember: boolean;
  intervalRefresh: number;

  getRemember(): boolean {
    return this.remember;
  }
  setRemember(remember: boolean) {
    this.remember = remember;
  }
  getIntervalRefresh(): number {
    return this.intervalRefresh;
  }
  setIntervalRefresh(minutes: number) {
    this.intervalRefresh = minutes;
  }
}
